/**
 * Utility function to remove undefined values from objects before saving to Firestore
 * Firestore doesn't accept undefined values, only null or missing fields
 */

// Shallow version - removes undefined values from top level
export const stripUndefined = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  );
};

// Deep version - recursively removes undefined values from nested objects
export const deepStripUndefined = (value) => {
  if (value === undefined) return undefined;
  
  if (Array.isArray(value)) {
    return value.map(deepStripUndefined);
  }
  
  if (value && typeof value === 'object') {
    const result = {};
    for (const [key, val] of Object.entries(value)) {
      const cleaned = deepStripUndefined(val);
      if (cleaned !== undefined) {
        result[key] = cleaned;
      }
    }
    return result;
  }
  
  return value;
};

// Convert undefined to null for Firestore compatibility
export const undefinedToNull = (obj) => {
  if (obj === undefined) return null;
  
  if (Array.isArray(obj)) {
    return obj.map(undefinedToNull);
  }
  
  if (obj && typeof obj === 'object') {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = undefinedToNull(value);
    }
    return result;
  }
  
  return obj;
};
